module.exports = __webpack_public_path__ + "img/scene-4.af768a3.png";